module.exports = __webpack_public_path__ + "assets/Gamma.01d79e5da3e65c85f28403e20eac482f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Gamma.png
// module id = 786
// module chunks = 0